import newspaperForm from "@/components/newspaper/newspaper-form-template"
// import { cloneDeep } from "lodash";

import InputFileItem from "@/components/utils/input-file-item"

import pageDefaultFields from "@/components/newspaper/default-form-props"

import { mapActions } from "vuex"

export default {
  components: {
    "image-upload": () => import("@/components/utils/image-upload"),
    InputFileItem,
    newspaperForm
  },

  data: () => ({
    props: {
      form: { ...pageDefaultFields },
      tabPane: null,

      emptyTitle: false,
      emptyContent: false,
      emptyExcerp: false,

      loading: false,
      pending: false,
      file_raw: null,
      image_raw: null
    }
  }),

  watch: {
    $route: {
      handler: "fetchData",
      immediate: true
    }
  },

  methods: {
    onSlugChange(e) {
      const text = (e.target.value || "")
        .replace(/( )/gi, "-")
        .toLowerCase()
        .replace(/[^a-zA-Z0-9\\-]/gi, "")

      // console.log(text);

      this.slugCheck({
        payload: { table: "post", slug: text },
        postType: "news"
      })

      // console.log('slug', this.props.form.slug);

      this.props.form.slug = text
    },
    ...mapActions("newspaper", ["detail", "deleteA", "submit"]),
    async fetchData() {
      if (!this.$route.params.slug) return

      this.loading = true
      try {
        const data = await this.detail(this.$route.params.slug)
        if (data) {
          this.props.form = data || {}

          if (data.date) {
            this.props.form.date = this.moment(data.date)
          }
        }
      } catch (err) {
        console.error(err)
        this.loading = false
      }
      this.loading = false
    },

    async submitForm() {
      let result = {
        done: "success",
        text: "Газета успешно " + (this.props.form.id ? "обновлена" : "создана")
      }

      if (!this.props.form.title) {
        this.$message.error("Введите заголовок")
        return
      }

      if (!this.props.form.excerpt) {
        this.$message.error("Введите подзаголовок")
        return
      }

      if (!this.props.form.id && !this.props.image_raw) {
        this.$message.error("Выберите фото газеты")
        return
      }

      if (!this.props.form.id && !this.props.file_raw) {
        this.$message.error("Выберите файл газеты")
        return
      }

      if (!this.props.form.date) {
        this.$message.error("Выберите дату публикации")
        return
      }

      try {
        this.props.pending = true

        const newspaper = (!this.props.form.id && {
          avatar_file: this.props.image_raw || this.props.form.avatar_file,
          paper_file: this.props.file_raw || this.props.form.paper_file,
          date: this.moment(this.props.form.date)
            .subtract({ hours: 5 })
            .format("YYYY-MM-DD HH:mm")
        }) || {
          image_path: this.props.image_raw || this.props.form.image_path,
          date: this.moment(this.props.form.date)
            .subtract({ hours: 5 })
            .format("YYYY-MM-DD HH:mm")
        }

        // eslint-disable-next-line no-unused-vars
        const { description, ...props } = this.props.form

        await this.submit({ ...props, ...newspaper })
        this.props.pending = false
      } catch (error) {
        console.error(error)
        this.props.pending = false
        result = {
          done: "error",
          text: "Не удалось создать газету" + " " + error
        }
      }

      this.$message[result.done](result.text)
      this.$router.go(-1)
    },

    async deleteConfirm(newspaperId) {
      if (confirm("Вы действительно хотите удалить газету?")) {
        try {
          this.props.pending = true
          await this.deleteA(newspaperId)
        } catch (error) {
          console.error(error)
          this.props.pending = false
        }
        this.props.pending = false
      }
    },

    tabPaneChangeHandler(arg) {
      // tinymce reload fix, !!! important
      this.tabPane = arg
    }
  }
}
